import { Token } from '@/utils/mm'


export const webSocket = {
    data() {
        return {
            isWebsock: false,
            websock: null, // 他这里应该少定义了一个对象
            websockTime: "", //心跳
            onMessageCallback: null, // message结果回调
            onOpenCallback: null // 连接成功之后的回调事件

        }
    },
    created() {
        // this.webSocketInit(); // 直接初始化websocket对象
    },
    methods: {
        /**
         * 这里其实是初始化了websocket对象
         * e {string} load=加载 get=获取
         */
        webSocketInit(onOpenCallback) {
            const self = this;
            if (typeof WebSocket === "undefined") {
                alert("Your browser does not support websocket");
            } else {
                try {
                    self.websock.close();
                    this.isWebsock = false;
                } catch (e) { console.log(e) }
                // 实例化socket
                const wsUrl = window.websocketUrl + "?Authorization=Bearer " + Token.get();// 让每个请求携带自定义token 请根据实际情况自行修改
                self.websock = new WebSocket(wsUrl);
                // 监听socket连接
                self.websock.onopen = self.websockOpen;
                // 监听socket错误信息
                self.websock.onerror = self.websockError;
                // 监听socket消息
                self.websock.onmessage = self.websockMessage;
                // 关闭socket连接
                self.websock.onclose = self.websockClose;
                // 连接成功之后的回调事件
                self.onOpenCallback = onOpenCallback;
            }
        },
        //打开websocket连接
        websockOpen(e) {
            const self = this;
            console.log("webSocketPin连接成功");
            if (this.websockTime) {
                clearInterval(this.websockTime);
            }
            this.isWebsock = true;
            // 开启心跳
            setTimeout(function () {
                self.websockTime = setInterval(function () {
                    self.websockHeartbeat();
                }, 10000);
            }, 1000);
            //处理回调事件
            if (self.onOpenCallback) {
                self.onOpenCallback();
            }
        },
        //发送消息
        websockSend(msg, onMessageCallback) {
            const self = this;
            if (this.isWebsock) {
                // console.log("发送socket消息:", msg);
                self.websock.send(msg);
                self.onMessageCallback = onMessageCallback;
            }
        },
        //错误
        websockError(e) {
            // console.log(e)
            //   console.log("连接错误");
            this.websockClose();
        },
        //监听返回消息
        websockMessage(msg) {
            const self = this;
            // console.log('messagePin', msg.data);
            let quotes = JSON.parse(msg.data);
            if (!quotes || quotes.length == 0) {
                return;
            }
            self.onMessageCallback(quotes);
        },
        //心跳
        websockHeartbeat() {
            const self = this;
            // console.log("发送websockHeartbeat消息1", this.isWebsock);
            if (this.isWebsock) {
                self.websock.send(JSON.stringify({
                    action: 'ping',
                    content: new Date().getTime()
                }));
            }
        },
        //连接关闭
        websockClose() {
            const self = this;
            if (this.isWebsock) {
                // 关闭之前要清空订阅
                const subRequest = {
                    action: 'SubClear',
                    content: []
                };
                self.websock.send(JSON.stringify(subRequest));
                self.websock.close();
            }
            clearInterval(this.websockTime);
            this.isWebsock = false;
            console.log("socket已经关闭");
        }
    }
}